import React, { useState } from 'react';
import { Input } from './ui/input';
import { Lock, Eye, EyeOff } from 'lucide-react';

// Password input with a lock icon and a show/hide (eye) toggle.
// Fully controlled; forwards common input props. Accessible: the toggle is a real
// button with an aria-label and does not submit the surrounding form (type=button).
export const PasswordField = ({
  value,
  onChange,
  placeholder = 'Password',
  testid = 'password-input',
  autoComplete = 'current-password',
  required = false,
  minLength,
  id,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Lock className="h-4 w-4 absolute left-3 top-3 text-muted-foreground pointer-events-none" />
      <Input
        id={id}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        className="pl-9 pr-10 h-11"
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Hide password' : 'Show password'}
        aria-pressed={show}
        className="absolute right-2 top-1.5 h-8 w-8 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none"
        data-testid={`${testid}-toggle`}
        tabIndex={0}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};

export default PasswordField;
